import PropTypes from 'prop-types';
import React from 'react';
import HotelSearchPrefsModal from './HotelSearchPrefsModal';

class HotelSearchPrefs extends React.Component {
  componentWillMount() {
    if (this.props.brandList.length === 0) {
      this.props.requestBrandOptions();
      this.props.requestBrandGroups();
    }
  }
  render() {
    if (this.props.show) {
      return (
        <HotelSearchPrefsModal
          groups={this.props.groups}
          brandList={this.props.brandList}
          brandGroups={this.props.brandGroups}
          savePreferences={this.props.saveSearchPreferences}
          show={this.props.show}
          onClose={this.props.onClose}
          eventId={this.props.tour.selectedTour.selectedEvent}
          tours={this.props.tour.selectedTour.tour.tour_stops}
          searchHotels={this.props.searchHotels}
        />
      );
    }
    return null;
  }
}

HotelSearchPrefs.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  brandList: PropTypes.arrayOf(PropTypes.object).isRequired,
  brandGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
  requestBrandOptions: PropTypes.func.isRequired,
  saveSearchPreferences: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

HotelSearchPrefs.defaultProps = {
  brandList: [],
  brandGroups: [],
};

export default HotelSearchPrefs;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelSearchPrefs.js